import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Card, Collapse, Flex, Tooltip, Typography } from "antd";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function Warning({ title, description, about, link, colecoes }) {
  const navigate = useNavigate();
  return (
    <Tooltip title={`Clique para adicionar uma ${about}`}>
      <Card
        style={{ width: "100%", height: "100%" }}
        bodyStyle={{ padding: "12px 16px" }}
        onClick={() => navigate(link)}>
        <Flex align="center" gap={40} style={{ width: "100%" }}>
          <ExclamationCircleOutlined
            style={{ color: "#ff720a", fontSize: "2rem" }}
          />
          <Flex vertical gap={4}>
            <Title level={4} style={{ margin: 0 }}>
              {title}
            </Title>
            <Text type="secondary">{description}</Text>
            {colecoes && colecoes.length > 0 && (
              <div
                style={{ marginTop: 8 }}
                onClick={(e) => e.stopPropagation()}>
                <Collapse size="small" ghost>
                  <Collapse.Panel header="Ver coleções" key="1">
                    <ul
                      style={{ margin: 0, paddingLeft: 10, listStyle: "none" }}>
                      {colecoes.map((col) => (
                        <li key={col.legacy_id}>
                          <Text>{col.description}</Text>
                        </li>
                      ))}
                    </ul>
                  </Collapse.Panel>
                </Collapse>
              </div>
            )}
          </Flex>
        </Flex>
      </Card>
    </Tooltip>
  );
}
